<template>
  <v-container class="admin-company">
    <v-row class="flex-grow-0">
      <v-col>
        <label class="text-h5">{{ $t('admin_hkiarace.company') }}</label>
      </v-col>
      <v-col class="text-right">
        <v-btn color="primary"
               @click="addCompanyModalShown = true">
          {{ $t('admin_hkiarace.add_company') }}
        </v-btn>
      </v-col>
    </v-row>
    <v-row class="flex-grow-1">
      <v-col class="pa-0">
        <CompanyList full-height
                     :refresh-trigger.sync="refreshTrigger"
                     @edit="onCompanyEdit"></CompanyList>
      </v-col>
    </v-row>
    
    <AddCompanyModal :shown="addCompanyModalShown"
                    @cancel="addCompanyModalShown = false"
                    @finish="onAddCompanyModalFinish"></AddCompanyModal>

    <EditCompanyModal :shown="editCompanyModalShown"
                     :company-id="editingCompanyId"
                     @cancel="editCompanyModalShown = false"
                     @finish="onEditCompanyModalFinish"></EditCompanyModal>
  </v-container>
</template>

<script>
import {ref} from "@vue/composition-api";
import CompanyList from "@/components/company/CompanyList";
import AddCompanyModal from "@/components/company/AddCompanyModal";
import EditCompanyModal from "@/components/company/EditCompanyModal";

export default {
  name: 'Company',
  components: {EditCompanyModal, AddCompanyModal, CompanyList},
  setup(props, {root}) {
    const refreshTrigger = ref(false);
    const refresh = function () {
      refreshTrigger.value = !refreshTrigger.value;
    };

    const addCompanyModalShown = ref(false);
    const onAddCompanyModalFinish = function (item) {
      addCompanyModalShown.value = false;
      refresh();
      onCompanyEdit(item);
    }

    const editingCompanyId = ref(null);
    const editCompanyModalShown = ref(false);
    const onCompanyEdit = function (item) {
      editingCompanyId.value = item.id;
      editCompanyModalShown.value = true;
    };
    const onEditCompanyModalFinish = function () {
      editCompanyModalShown.value = false;
      refresh();
    }
    
    return {
      refreshTrigger,
      refresh,

      addCompanyModalShown,
      onAddCompanyModalFinish,

      editingCompanyId,
      editCompanyModalShown,
      onCompanyEdit,
      onEditCompanyModalFinish,
    }
  },
}
</script>

<style lang="less">
.admin-company {
  height: 100%;
  display: flex;
  flex-direction: column;
}
</style>
